import { render } from "./ProfileCardHeaderInternal.vue?vue&type=template&id=dfda8748&scoped=true"
import script from "./ProfileCardHeaderInternal.vue?vue&type=script&lang=js"
export * from "./ProfileCardHeaderInternal.vue?vue&type=script&lang=js"

import "./ProfileCardHeaderInternal.vue?vue&type=style&index=0&id=dfda8748&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfda8748"]])

export default __exports__